<div class="kContainer">
  <div class="spinner-container">
    <div class="spinner">
      <span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span>
    </div>
  </div>
  <span class="kNote">{{ 'app.redirect.redirect1' | translate }}</span>
  <div>
    <span class="kNote">{{ 'app.redirect.redirect2' | translate }}</span>
    <a (click)="navigateToDefault()">{{ 'app.redirect.redirect3' | translate }}</a>
  </div>
</div>
